import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { isDesktopMediaQuery } from "../../constants/constants";

interface ModalHOCProps {
    isActive: boolean;
    modalPosition?: {
        left?: boolean;
        right?: boolean;
        top?: boolean;
        bottom?: boolean;
    };
    effect?: "menu-push" | "menu-parallax";
    onClose: () => void;
    backdropClickDisabled?: boolean,
    disableBackdropClick?: (disable: boolean) => void,
    headerRightComponent?: React.ReactNode
}

const withSlideUpModal = <P extends object>(WrappedComponent: React.ComponentType<P>, title?: string, noPadding?: boolean) => {
    const ModalHOC: React.FC<P & ModalHOCProps> = ({
        isActive,
        backdropClickDisabled = false,
        disableBackdropClick,
        modalPosition = { bottom: true },
        effect = "menu-push",
        onClose,
        headerRightComponent,
        ...props
    }) => {
        const [transformStyles, setTransformStyles] = useState("");
        const isDesktop = useMediaQuery(isDesktopMediaQuery);

        useEffect(() => {
            const menuWidth = 350; // Example width
            const menuHeight = 400; // Example height

            if (isActive) {
                if (effect === "menu-push") {
                    if (modalPosition.left) setTransformStyles(`translateX(${menuWidth}px)`);
                    if (modalPosition.right) setTransformStyles(`translateX(-${menuWidth}px)`);
                    if (modalPosition.top) setTransformStyles(`translateY(${menuHeight}px)`);
                    if (modalPosition.bottom) setTransformStyles(`translateY(-${menuHeight}px)`);
                } else if (effect === "menu-parallax") {
                    if (modalPosition.left) setTransformStyles(`translateX(${menuWidth / 10}px)`);
                    if (modalPosition.right) setTransformStyles(`translateX(-${menuWidth / 10}px)`);
                    if (modalPosition.top) setTransformStyles(`translateY(${menuHeight / 5}px)`);
                    if (modalPosition.bottom) setTransformStyles(`translateY(-${menuHeight / 5}px)`);
                }
            } else {
                setTransformStyles(""); // Reset styles when inactive
            }
        }, [isActive, effect, modalPosition]);

        const onBackDropClick = () => {
            if (backdropClickDisabled) return;
            onClose();
        }

        return (
            <>
                {/* Menu Hider */}
                <div
                    className={`menu-hider ${isActive ? "menu-active" : ""}`}
                    onClick={onBackDropClick}
                ></div>

                {/* Modal Wrapper */}
                <div
                    className={`menu menu-box-bottom rounded-m bg-theme ${isActive ? "menu-active" : ""}`}
                    style={{ transform: transformStyles, left: 'auto', right: 'auto', width: isDesktop ? '768px' : '100%', maxHeight: '90%' }}
                    data-menu-width="350"
                    data-menu-height="400"
                >
                    {/* Pass down modal-related props */}
                    <div className="new-slide-up-modal">
                        <div className="modal-bar-wrapper">
                            <div className="modal-bar"></div>
                        </div>
                        {
                            (title || headerRightComponent) &&
                            <div className="modal-slide-up-header d-flex justify-content-between align-items-center">
                                <h6 className="modal-slide-up-header-title mb-0">
                                    {title}
                                </h6>
                                {
                                    headerRightComponent
                                }
                            </div>
                        }
                        <div className={`new-slide-up-modal-body  ${noPadding ? 'p-0' : ''}`}>
                            {
                                isActive &&
                                <WrappedComponent {...(props as P)} onClose={onClose} disableBackdropClick={disableBackdropClick} />
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    };

    return ModalHOC;
};

export default withSlideUpModal;